import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { reduxForm } from 'antd-form-redux';
import { Skeleton, Form, Row, Col, Input, Icon } from 'antd';
import { styleGutterRow } from '../../common/configConstants';

export class FormRegistroAgendamentoRpa extends Component {
  static propTypes = {
    loginSap: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleSubmit = () => {
    this.props.submitForm(this.props.form);
  }

  render() {
    const { loginSap, registro, formRef, form: { getFieldDecorator } } = this.props;

    return (
      <div className="login-sap-form-registro-agendamento-rpa">
        <Skeleton
          active
          loading={loginSap.buscarAgendamentoRpaPending}
        >
          <Form
            layout="horizontal"
            ref={formRef}
            onSubmit={this.handleSubmit}
          >
            <Row gutter={styleGutterRow}>
              <Col md={12}>
                <Form.Item label="Ambiente">
                  {getFieldDecorator('SAP_Ambiente', {
                    initialValue: registro.SAP_Ambiente,
                    rules: [{ required: true, message: 'Campo obrigatório!' }],
                  })(
                    <Input prefix={<Icon type="desktop" />} placeholder='Informe o amibiente SAP' />
                  )}
                </Form.Item>
              </Col>
              <Col md={6}>
                <Form.Item label="Usuário">
                  {getFieldDecorator('SAP_User', {
                    initialValue: registro.SAP_User,
                    rules: [{ required: true, message: 'Campo obrigatório!' }],
                  })(
                    <Input prefix={<Icon type="user" />} placeholder='Usuário SAP' />
                  )}
                </Form.Item>
              </Col>
              <Col md={6}>
                <Form.Item label="Senha">
                  {getFieldDecorator('SAP_Password', {
                    initialValue: null,
                    rules: [{ required: true, message: 'Campo obrigatório!' }],
                  })(
                    <Input.Password visibilityToggle={false} prefix={<Icon type="lock" />} placeholder='Senha SAP' />
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Skeleton>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    loginSap: state.loginSap,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

FormRegistroAgendamentoRpa = reduxForm({
  form: 'FormRegistroAgendamentoRpa',
})(FormRegistroAgendamentoRpa);

FormRegistroAgendamentoRpa = connect(
  mapStateToProps,
  mapDispatchToProps
)(FormRegistroAgendamentoRpa);

export default FormRegistroAgendamentoRpa;



// WEBPACK FOOTER //
// ./src/features/login-sap/FormRegistroAgendamentoRpa.js